"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "common": "navigation-module__common___r1x4t",
  "skeleton_container": "navigation-module__skeleton_container___ePkdk",
  "skeleton_links": "navigation-module__skeleton_links___w8N0V",
  "skeleton_link": "navigation-module__skeleton_link___ZTF_s",
  "primary": "navigation-module__primary___l2FkT navigation-module__common___r1x4t",
  "navitem": "navigation-module__navitem___IP3iU",
  "link": "navigation-module__link___D8ugR",
  "selected": "navigation-module__selected___JSbF4",
  "alone": "navigation-module__alone___zRRYr",
  "subnav": "navigation-module__subnav___yOe_T",
  "secondary": "navigation-module__secondary___RINdB navigation-module__common___r1x4t",
  "nolink": "navigation-module__nolink___Zs87Y"
};
const NavLinkIntl = (0, _reactIntl.injectIntl)(class NavigationLink extends _react.Component {
  static propTypes = {
    className: T.string,
    activeClassName: T.string,
    destination: T.string,
    label: T.string,
    labelId: T.string,
    labelClassName: T.string,
    blockLink: T.bool,
    selected: T.bool,
    onClick: T.func,
    isVisible: T.bool,
    tcl: T.string,
    labelValues: T.object
  };
  static defaultProps = {
    className: '',
    activeClassName: '',
    destination: '#',
    selected: false,
    onClick: _constants.NOOP,
    isVisible: true
  };

  // this function is a good candiate for a simple component
  renderLink(content, renderChildren, className) {
    const {
      destination,
      selected,
      onClick,
      children,
      activeClassName,
      tcl,
      labelClassName
    } = this.props;
    const classNames = (0, _classnames.default)(styles.link, {
      [styles.selected]: selected,
      [activeClassName]: selected
    }, className);

    // only wrap in a span if a class is specified
    content = content && labelClassName ? /*#__PURE__*/_react.default.createElement("span", {
      className: labelClassName
    }, content) : content;
    if (destination === '#') {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(styles.link, styles.nolink, classNames),
        onClick: onClick,
        "data-tcl": tcl
      }, content, renderChildren && children);
    } else if ((0, _startsWith.default)(destination).call(destination, 'https://')) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: classNames,
        href: destination,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: "_blank"
      }, content);
    }
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      to: destination,
      className: classNames,
      activeClassName: (0, _classnames.default)(styles.selected, activeClassName),
      "data-tcl": tcl,
      onClick: onClick
    }, content, renderChildren && children);
  }
  render() {
    const {
      label,
      labelId,
      blockLink,
      intl,
      children,
      className,
      isVisible,
      labelValues
    } = this.props;
    if (!isVisible) return false;
    const linkContent = typeof label === 'string' ? label : intl.formatMessage({
      id: labelId
    }, labelValues);
    if (!blockLink) {
      return this.renderLink(linkContent, true, className);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.navitem, {
        [styles.alone]: !children
      }, className)
    }, this.renderLink(linkContent, false), children);
  }
});
class Navigation extends _react.Component {
  static propTypes = {
    navLinks: T.arrayOf(T.object).isRequired,
    type: T.oneOf(['primary', 'secondary']),
    isSubNav: T.bool,
    className: T.string
  };
  static defaultProps = {
    type: 'secondary',
    isSubNav: false,
    className: ''
  };
  render() {
    const {
      type,
      navLinks,
      isSubNav,
      className
    } = this.props;
    const navigation = (0, _map.default)(navLinks).call(navLinks, (link, i) => {
      if (link.navLinks) {
        return /*#__PURE__*/_react.default.createElement(NavLinkIntl, (0, _extends2.default)({}, link, {
          key: `navItem#${i}`,
          blockLink: true,
          tcl: link.tcl
        }), /*#__PURE__*/_react.default.createElement(Navigation, {
          key: `navSubItem#${i}`,
          type: type,
          navLinks: link.navLinks,
          isSubNav: true
        }));
      } else if (link.component) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: link.className,
          key: `navItemComponent#${i}`
        }, link.component);
      } else {
        // TODO: add legend class?
        const legend = 'legend' in link ? /*#__PURE__*/_react.default.createElement("span", {
          className: "legend"
        }, link.legend) : false;
        return /*#__PURE__*/_react.default.createElement(NavLinkIntl, (0, _extends2.default)({}, link, {
          key: `navItem#${i}`,
          blockLink: type === 'primary',
          tcl: link.tcl
        }), legend);
      }
    });
    if (navLinks) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(className, {
          [styles.subnav]: isSubNav,
          [styles[type]]: !isSubNav
        })
      }, navigation);
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.skeleton_container
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.skeleton_links
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.skeleton_link
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.skeleton_link
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.skeleton_link
      }));
    }
  }
}
exports.default = Navigation;